import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, getAreas } from '../../services/apiService';
import './ShopLoginPage.css';

// TEMP: default demo credentials — remove before production launch
const DEMO_EMAIL = 'winkelier@walkin.nl';
const DEMO_PASSWORD = 'Walkin2026!';

export default function ShopLoginPage() {
  const navigate = useNavigate();
  // TEMP: default demo credentials — remove before production launch
  // Pre-fill only; handleSubmit still runs the normal login() auth flow.
  const [email, setEmail] = useState(DEMO_EMAIL);
  const [password, setPassword] = useState(DEMO_PASSWORD);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      // login() stores the JWT + user in sessionStorage under
      // walkin_auth_token / walkin_auth_user for subsequent API calls.
      const data = await login(email, password);
      const r = data.retailer || data.user || {};

      // Resolve the area name from the retailer's areaId so the rest of the
      // app (dashboard, deal creation) can keep using walkin_shop_area.
      let areaName = '';
      if (r.areaId) {
        try {
          const areas = await getAreas();
          areaName = areas.find((a) => a.id === r.areaId)?.name || '';
        } catch { /* non-fatal */ }
      }

      // Populate the legacy session keys the existing shop pages read as their
      // "logged in" gate + profile so nothing downstream needs rewriting.
      sessionStorage.setItem('walkin_shop_mode', 'true');
      sessionStorage.setItem('walkin_shop_name', r.name || '');
      sessionStorage.setItem('walkin_shop_area', areaName);
      sessionStorage.setItem('walkin_shop_email', (r.email || email).toLowerCase().trim());
      sessionStorage.setItem('walkin_shop_profile', JSON.stringify({
        shopName: r.name || '',
        areaName,
        email: (r.email || email).toLowerCase().trim(),
      }));
      sessionStorage.removeItem('walkin_demo_mode');

      navigate('/shop/dashboard');
    } catch (err) {
      if (err?.status === 401) {
        setError('Onbekend e-mailadres of wachtwoord');
      } else if (err?.status === 403) {
        setError('Dit account is geblokkeerd. Neem contact op met support.');
      } else {
        setError(err?.message || 'Inloggen mislukt. Probeer het opnieuw.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="shop-login">
      <div className="shop-login__content">
        <div className="shop-login__logo">
          <span className="shop-login__logo-walk">Walk</span>
          <span className="shop-login__logo-in">In</span>
        </div>
        <div className="shop-login__badge">Winkeliers modus 🏪</div>

        <h1 className="shop-login__title">Inloggen als winkelier</h1>

        {/* TEMP: default demo credentials — remove before production launch */}
        <p className="shop-login__demo-note">
          Demo toegang — verander dit voor live gebruik
        </p>

        <form className="shop-login__form" onSubmit={handleSubmit}>
          <label className="shop-login__field">
            <span className="shop-login__label">E-mailadres</span>
            <input
              type="email"
              className="shop-login__input"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              placeholder="naam@winkel.nl"
              autoComplete="email"
              required
            />
          </label>

          <label className="shop-login__field">
            <span className="shop-login__label">Wachtwoord</span>
            <input
              type="password"
              className="shop-login__input"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </label>

          {error && <div className="shop-login__error">{error}</div>}

          <button type="submit" className="shop-login__submit" disabled={submitting}>
            {submitting ? 'Bezig met inloggen…' : 'Inloggen'}
          </button>

          <button
            type="button"
            className="shop-login__forgot"
            onClick={() => navigate('/shop/forgot-password')}
          >
            Wachtwoord vergeten?
          </button>
        </form>

        <button
          type="button"
          className="shop-login__signup"
          onClick={() => navigate('/shop/signup')}
        >
          Nog geen account? Aanmelden →
        </button>

        <button
          type="button"
          className="shop-login__back"
          onClick={() => navigate('/')}
        >
          Terug naar deals →
        </button>
      </div>
    </div>
  );
}
